import { useEffect } from "react";
import { useConsent } from "../contexts/ConsentContext";

function injectScript(id, src, inlineCode) {
  if (document.getElementById(id)) return;
  const s = document.createElement("script");
  s.id = id;
  if (src) {
    s.src = src;
    s.async = true;
  }
  if (inlineCode) {
    s.textContent = inlineCode;
  }
  document.head.appendChild(s);
}

function removeScript(id) {
  const el = document.getElementById(id);
  if (el && el.parentNode) el.parentNode.removeChild(el);
}

function upsertMeta(name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

/**
 * Inject GA4, FB Pixel, and GSC verification — but ONLY when user has given consent
 * (analytics for GA4, marketing for FB Pixel). GSC verification meta tag is always
 * fine because it's a static identification meta (no tracking).
 */
export default function SeoTrackers({ seo }) {
  const { consent } = useConsent();

  useEffect(() => {
    if (!seo) return;
    // GSC verification is just a meta tag, no tracking — always set
    if (seo.google_site_verification) {
      upsertMeta("google-site-verification", seo.google_site_verification);
    }

    const analyticsAllowed = consent?.analytics === true;
    const marketingAllowed = consent?.marketing === true;

    if (seo.ga_measurement_id && analyticsAllowed) {
      const gid = seo.ga_measurement_id;
      injectScript(`ga-src-${gid}`, `https://www.googletagmanager.com/gtag/js?id=${gid}`);
      injectScript(
        `ga-inline-${gid}`,
        null,
        `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '${gid}');`,
      );
    } else if (seo.ga_measurement_id && !analyticsAllowed) {
      removeScript(`ga-src-${seo.ga_measurement_id}`);
      removeScript(`ga-inline-${seo.ga_measurement_id}`);
    }

    if (seo.fb_pixel_id && marketingAllowed) {
      const fid = seo.fb_pixel_id;
      injectScript(
        `fb-pixel-${fid}`,
        null,
        `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js'); fbq('init', '${fid}'); fbq('track', 'PageView');`,
      );
    } else if (seo.fb_pixel_id && !marketingAllowed) {
      removeScript(`fb-pixel-${seo.fb_pixel_id}`);
    }
  }, [seo, consent]);

  return null;
}
